export const hrefs = {
  personal: {
    email: "mailto:michael@webdesserts.com",
    website: "https://webdesserts.com",
    linkedin: "https://www.linkedin.com/in/webdesserts",
    bluesky: "https://bsky.app/profile/webdesserts.com",
    github: "https://github.com/webdesserts",
    twitch: "https://twitch.tv/webdesserts",
  },
  ctzn: {
    website: "https://ctznry.com/",
    github: "https://github.com/pfrazee/ctznry",
  },
  hyper: {
    website: "https://hypercore-protocol.org/",
    github: "https://github.com/hypercore-protocol",
  },
  beaker: {
    website: "https://beakerbrowser.com/",
    github: "https://github.com/beakerbrowser",
  },
  cabal: {
    website: "https://cabal-club.github.io/",
    github: "https://github.com/cabal-club",
  },
  logger: {
    figma:
      "https://www.figma.com/file/YTQS6iZHzqMQPlewPs83sHLq/Web-Desserts?node-id=40%3A48",
    github: "https://github.com/webdesserts/logger",
  },
  dots_cli: {
    github: "https://github.com/webdesserts/dots-cli",
    crate: "https://crates.io/crates/dots",
  },
  at_protocol: {
    website: "https://atproto.com/",
    github: "https://github.com/bluesky-social/atproto",
  },
  nushell: {
    website: "https://www.nushell.sh/",
    github: "https://github.com/nushell/nushell",
  },
};
